import { c as _c } from "react/compiler-runtime";
import { CallSolid, Link as LinkIcon, MapPinSolid } from '@byway/icons';
import { Image, StructuredText } from 'react-datocms';
import { Divider } from '~/components/Divider';
import { Link } from '~/components/Link';
import { hasFeatureText, isEmptyStructuredText, isNotEmptyString } from '~/utils/datoHelpers';

// import { AccessTimes } from '~/components/AccessTimes/AccessTimes'
import type { ActivityProps } from './Activity.types';
const Activity = t0 => {
  const $ = _c(23);
  const {
    activity,
    isDetailed
  } = t0;
  let t1;
  if ($[0] !== activity) {
    t1 = activity ?? {};
    $[0] = activity;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    activityTitle,
    address,
    description,
    featuredDescription,
    featuredTitle,
    furtherDetails,
    images,
    location,
    telephone,
    url
  } = t1;
  let t2;
  if ($[2] !== activityTitle || $[3] !== description || $[4] !== featuredDescription || $[5] !== featuredTitle || $[6] !== images || $[7] !== isDetailed) {
    t2 = !isDetailed && <header className="flex align-center">{images?.[0]?.responsiveImage && <div className="w-[60px] h-[60px] mr-8px relative shrink-0"><Image data={images[0].responsiveImage} layout="fill" objectFit="cover" /></div>}<div><h4 className="capitalize typography-subtitle-2 mb-4px">{hasFeatureText(featuredTitle, activityTitle)}</h4><div dangerouslySetInnerHTML={{
          __html: hasFeatureText(featuredDescription, description)
        }} className="prose-a:underline" /></div></header>;
    $[2] = activityTitle;
    $[3] = description;
    $[4] = featuredDescription;
    $[5] = featuredTitle;
    $[6] = images;
    $[7] = isDetailed;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] !== activityTitle || $[10] !== address || $[11] !== description || $[12] !== featuredDescription || $[13] !== featuredTitle || $[14] !== furtherDetails || $[15] !== isDetailed || $[16] !== location || $[17] !== telephone || $[18] !== url) {
    t3 = isDetailed && <><h1 className="capitalize typography-title-5 mb-4px"><span className="font-serif">{hasFeatureText(featuredTitle, activityTitle)}</span></h1><p className="mb-16px" dangerouslySetInnerHTML={{
        __html: hasFeatureText(featuredDescription, description)
      }} /><Divider variant="horizontal" />{address && address.length > 0 && <div className="mt-16px"><p className="typography-chip-style text-neutral-600 mb-8px">Address</p><p className="typography-body-2 mb-16px">{address}</p></div>}{furtherDetails && !isEmptyStructuredText(furtherDetails) && <><Divider variant="horizontal" /><div className="my-16px"><p className="typography-chip-style text-neutral-600 mb-8px">Details</p><div className="space-y-12px typography-body-2"><StructuredText data={furtherDetails} /></div></div></>}<ul className="border-t border-b divide-y divide-solid border-neutral-300 divide-neutral-300 mb-48px">{location && <li className="py-16px"><Link hasUnderline={false} href={`https://www.google.com/maps/search/?api=1&query=${location.latitude}%2C${location.longitude}`} isExternal={true}><span className="flex items-center gap-2 typography-button"><MapPinSolid decorative={true} size="large" /><span>See location</span></span></Link></li>}{isNotEmptyString(telephone) && <li className="py-16px"><Link hasUnderline={false} href={`tel:${telephone}`}><span className="flex items-center gap-2 typography-button"><CallSolid decorative={true} size="large" /><span>Call</span></span></Link></li>}{isNotEmptyString(url) && <li className="py-16px"><Link hasUnderline={false} href={url} isExternal={true}><span className="flex items-center gap-2 typography-button"><LinkIcon decorative={true} size="large" /><span>Website</span></span></Link></li>}</ul></>;
    $[9] = activityTitle;
    $[10] = address;
    $[11] = description;
    $[12] = featuredDescription;
    $[13] = featuredTitle;
    $[14] = furtherDetails;
    $[15] = isDetailed;
    $[16] = location;
    $[17] = telephone;
    $[18] = url;
    $[19] = t3;
  } else {
    t3 = $[19];
  }
  let t4;
  if ($[20] !== t2 || $[21] !== t3) {
    t4 = <>{t2}{t3}</>;
    $[20] = t2;
    $[21] = t3;
    $[22] = t4;
  } else {
    t4 = $[22];
  }
  return t4;
};
export { Activity };